export default __webpack_public_path__ + "static/media/ar.186b3b92.jpg";